// extracted by mini-css-extract-plugin
export var decrement = "numeric-input-module--decrement--6bed2";
export var increment = "numeric-input-module--increment--a5a57";
export var input = "numeric-input-module--input--31854";
export var wrap = "numeric-input-module--wrap--f4bbd";